export default {
  hero: {
    eyebrow: "AllChinaBuy Spreadsheet",
    title: "Find bedre produkter med AllChinaBuy Spreadsheet",
    subtitle:
      "Udforsk organiserede AllChinaBuy spreadsheet-ressourcer, produktfund, sælgerinformation, QC-guides, forsendelsestips, anmeldelser og praktiske købsreferencer — alt på ét sted.",
    previewTitle: "Spreadsheet-eksempel",
    previewCols: {
      category: "Kategori",
      product: "Produkt",
      seller: "Sælger",
      price: "Pris",
      qc: "QC",
      shipping: "Forsendelse",
      updated: "Opdateret",
    },
    previewRows: {
      r1: ["Sko", "Lave sneakers", "Verificeret", "$$", "Godkendt", "5–12 dage", "I dag"],
      r2: ["Hættetrøjer", "Oversize hoodie", "Populær", "$$", "Godkendt", "5–12 dage", "I dag"],
      r3: ["T-shirts", "Boxy tee", "Verificeret", "$", "Godkendt", "4–10 dage", "I dag"],
      r4: ["Tasker", "Hverdagstote", "Populær", "$$", "Afventer", "6–14 dage", "I dag"],
    },
  },
  what: {
    title: "Hvad er AllChinaBuy Spreadsheet?",
    body1:
      "AllChinaBuy Spreadsheet er en praktisk måde at organisere og opdage produktressourcer, kategorier, sælgerinformation og nyttige købsreferencer på.",
    body2:
      "I stedet for at søge gennem spredte sider kan du bruge vores strukturerede guides og spreadsheet-ressourcer til at sammenligne produkter, forstå QC-information, undersøge forsendelsesmuligheder og træffe mere informerede beslutninger.",
  },
  categories: {
    title: "Populære AllChinaBuy Spreadsheet-kategorier",
    subtitle:
      "Gennemse organiserede produktkategorier, og fortsæt til de tilsvarende sider på vores hovedside.",
    select: "Gå til en kategori",
    viewAll: "Se alle kategorier",
  },
  before: {
    title: "Alt du skal vide, før du køber",
    cards: {
      review: {
        title: "AllChinaBuy anmeldelse",
        text: "Forstå platformen, arbejdsgangen, fordelene og eventuelle begrænsninger.",
      },
      shipping: {
        title: "AllChinaBuy forsendelsesomkostninger",
        text: "Lær, hvad der kan påvirke forsendelsesomkostninger, leveringsmetoder og samlede udgifter.",
      },
      warehouse: {
        title: "AllChinaBuy lager",
        text: "Forstå opbevaring, QC-inspektion og lagerrelaterede overvejelser.",
      },
      coupon: {
        title: "AllChinaBuy kupon",
        text: "Find information om kuponer, kampagner, og hvordan rabattilbud generelt fungerer.",
      },
      discount: {
        title: "AllChinaBuy rabatkode",
        text: "Lær, hvordan rabatkoder kan fungere, og hvad du skal tjekke, før du bruger en.",
      },
      legit: {
        title: "Er AllChinaBuy legitimt",
        text: "Forstå vigtige overvejelser om legitimitet, sikkerhed og verifikation.",
      },
    },
  },
  compare: {
    title: "Sammenlign, før du køber",
    subtitle: "Brug disse sammenligningspunkter til at træffe mere informerede valg.",
    headers: {
      topic: "Emne",
      check: "Hvad du skal tjekke",
      considerations: "Vigtige overvejelser",
      bestFor: "Bedst til",
    },
    rows: {
      products: {
        topic: "Produkter",
        check: "Billeder, mål, materialer",
        considerations: "Sammenlign flere opslag, før du vælger",
        bestFor: "At finde det rette produkt",
      },
      sellers: {
        topic: "Sælgere",
        check: "Anmeldelser, historik, respons",
        considerations: "Foretræk sælgere med klare historikker",
        bestFor: "At mindske risiko",
      },
      shipping: {
        topic: "Forsendelse",
        check: "Metode, vægt, destination",
        considerations: "Tungere varer koster ofte mere",
        bestFor: "At planlægge budgettet",
      },
      qc: {
        topic: "QC",
        check: "Inspektionsbilleder, mål",
        considerations: "Bed om QC før forsendelse, når muligt",
        bestFor: "At opdage problemer tidligt",
      },
      categories: {
        topic: "Kategorier",
        check: "Relevant produkttype",
        considerations: "Start fra den rette kategori",
        bestFor: "Hurtigere browsing",
      },
      buying: {
        topic: "Købsmetoder",
        check: "Checkout-flow, betaling",
        considerations: "Forstå processen, før du bestiller",
        bestFor: "En glattere checkout",
      },
    },
  },
  how: {
    title: "Sådan fungerer AllChinaBuy Spreadsheet",
    steps: {
      s1: { title: "Vælg en kategori", text: "Start fra den kategori, der matcher dit behov." },
      s2: { title: "Udforsk spreadsheet-ressourcer", text: "Gennemgå de organiserede produkt- og sælgerreferencer." },
      s3: { title: "Sammenlign produkt og sælger", text: "Afvej mulighederne side om side, før du beslutter." },
      s4: { title: "Tjek QC og købsovervejelser", text: "Forstå, hvad du skal verificere, før du bestiller." },
      s5: { title: "Undersøg forsendelse og lager", text: "Vurder omkostninger, leveringstid og opbevaring." },
      s6: { title: "Fortsæt til hovedsiden", text: "Gå til vores hovedside, når du er klar til at købe." },
    },
  },
  qc: {
    title: "AllChinaBuy QC & sikkerhedsguide",
    body: "Hold disse praktiske punkter i tankerne, før du bestiller.",
    items: {
      photos: { title: "QC-billeder", text: "Gennemgå inspektionsbilleder, og bed om ekstra billeder, når muligt." },
      inspection: { title: "Produktinspektion", text: "Tjek mål, etiketter og den generelle tilstand." },
      seller: { title: "Sælgerverifikation", text: "Se på sælgers historik og feedback, før du køber." },
      descriptions: { title: "Produktbeskrivelser", text: "Læs opslagene omhyggeligt for at bekræfte størrelse og materiale." },
      payment: { title: "Betalingsbevidsthed", text: "Brug kun den officielle checkout-proces." },
      shipping: { title: "Forsendelsesrisici", text: "Forstå leveringstider og mulige forsinkelser." },
      refund: { title: "Refusionsovervejelser", text: "Kend refusionspolitikken, før du forpligter dig." },
      personal: { title: "Personlige oplysninger", text: "Beskyt dine oplysninger, og undgå ubekræftede kontakter." },
      scam: { title: "Advarselstegn på svindel", text: "Vær forsigtig med tilbud, der virker for gode til at være sande." },
    },
    read: "Læs sikkerhedsguiden",
  },
  guides: {
    title: "Seneste AllChinaBuy guides & anmeldelser",
    subtitle: "Udforsk vores originale guides skrevet til praktisk og nyttig købsinformation.",
    card1: {
      category: "Spreadsheet-guide",
      title: "Hvad er AllChinaBuy Spreadsheet? Komplet 2026-guide",
      summary: "En komplet gennemgang af, hvordan spreadsheetet fungerer, hvad det indeholder, og hvordan du bruger det.",
      date: "Opdateret 2026",
      cta: "Læs guide",
    },
    card2: {
      category: "QC & sikkerhed",
      title: "AllChinaBuy QC & sikkerheds-tjekliste",
      summary: "Praktiske punkter at verificere før køb, fra QC-billeder til sælgerkontrol.",
      date: "Opdateret 2026",
      cta: "Læs mere",
    },
    card3: {
      category: "Forsendelse",
      title: "AllChinaBuy forsendelse & omkostninger",
      summary: "Hvad der påvirker forsendelsesomkostninger, leveringstid og lageropbevaring.",
      date: "Opdateret 2026",
      cta: "Læs mere",
    },
  },
  faq: {
    title: "Ofte stillede spørgsmål",
    items: {
      q1: {
        q: "Hvad er et AllChinaBuy Spreadsheet?",
        a: "Det er en organiseret ressource, der samler produktfund, kategorier, sælgere og købsreferencer, så du lettere kan sammenligne muligheder, før du bestiller.",
      },
      q2: {
        q: "Hvordan fungerer spreadsheetet?",
        a: "Du starter fra en kategori, udforsker de organiserede ressourcer, sammenligner produkter og sælgere, tjekker QC og forsendelse og fortsætter derefter til hovedsiden.",
      },
      q3: {
        q: "Er AllChinaBuy legitimt?",
        a: "AllChinaBuy er en shopping-agent-lignende platform, som mange købere bruger. Foretag din egen verifikation, tjek sælgers historik, og læs vilkårene, før du bestiller.",
      },
      q4: {
        q: "Er AllChinaBuy sikkert?",
        a: "Brug den officielle checkout-proces, beskyt dine personlige oplysninger, og vær forsigtig med tilbud, der virker for gode til at være sande.",
      },
      q5: {
        q: "Hvor meget koster AllChinaBuy forsendelse?",
        a: "Omkostningen afhænger af vægt, mål, metode og destination. Tungere og større varer koster ofte mere, og hurtigere metoder har typisk en højere pris.",
      },
      q6: {
        q: "Har AllChinaBuy kuponer?",
        a: "Kuponer og kampagner varierer over tid. Tjek hovedsiden for aktuelle tilbud, og læs altid vilkårene, før du bruger en kode.",
      },
      q7: {
        q: "Hvad er AllChinaBuy-lageret?",
        a: "Lageret er stedet, hvor varer kan opbevares og inspiceres, før de sendes. Opbevaring og QC kan påvirke din samlede omkostning og tidsplan.",
      },
      q8: {
        q: "Hvordan tjekker jeg QC?",
        a: "Bed om QC-billeder, gennemgå mål, etiketter og tilstand, og sammenlign med beskrivelsen, før du godkender forsendelse.",
      },
      q9: {
        q: "Hvordan sammenligner jeg produkter?",
        a: "Brug sammenligningspunkterne ovenfor: tjek billeder, sælgere, forsendelse, QC og kategorier side om side for at træffe et mere informeret valg.",
      },
    },
  },
  finalCta: {
    title: "Klar til at udforske mere?",
    body: "Find organiserede ressourcer, praktiske guides og nyttig købsinformation, før du foretager dit næste køb.",
    button: "Udforsk Spreadsheet",
    secondary: "Besøg hovedsiden",
  },
};